import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminUsers } from "@/components/admin/AdminUsers";
import { AdminPartners } from "@/components/admin/AdminPartners";
import { AdminProjects } from "@/components/admin/AdminProjects";

export default function Admin() {
  const { user } = useAuth();
  const [partners, setPartners] = useState([]);
  const [params] = useSearchParams();
  const loadPartners = () => api.get("/admin/partners").then((r) => setPartners(r.data));
  useEffect(() => { if (user?.role === "admin") loadPartners(); }, [user]);

  if (user?.role !== "admin") return <Navigate to="/" replace />;
  if (params.get("tab") === "crm") return <Navigate to={`/crm${params.get("client") ? `?client=${params.get("client")}` : ""}`} replace />;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6" data-testid="admin-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-genis">Mode administrateur</p>
        <h1 className="text-3xl font-extrabold font-heading tracking-tight text-genis-deep dark:text-white">Administration</h1>
        <p className="text-muted-foreground mt-1">Gérez les partenaires, les comptes utilisateurs et consultez toutes les simulations.</p>
      </div>
      <Tabs defaultValue={params.get("tab") || "users"}>
        <TabsList data-testid="admin-tabs">
          <TabsTrigger value="users" data-testid="admin-tab-users">Utilisateurs</TabsTrigger>
          <TabsTrigger value="partners" data-testid="admin-tab-partners">Partenaires</TabsTrigger>
          <TabsTrigger value="projects" data-testid="admin-tab-projects">Simulations</TabsTrigger>
        </TabsList>
        <TabsContent value="users" className="mt-5"><AdminUsers partners={partners} /></TabsContent>
        <TabsContent value="partners" className="mt-5"><AdminPartners partners={partners} reload={loadPartners} /></TabsContent>
        <TabsContent value="projects" className="mt-5"><AdminProjects partners={partners} focus={params.get("partner")} /></TabsContent>
      </Tabs>
    </div>
  );
}
